import script from "./userSettings.vue?vue&type=script&lang=js"
export * from "./userSettings.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__